import { useState } from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { emailAuth } from "@utils/emailAuthUtils.ts";
import { baseUrl } from "@app/query.ts";
import { useMsal } from "@azure/msal-react";
import { Alert, Button, Link, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const TokenHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance } = useMsal();
  const { t } = useTranslation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >(token ? "idle" : "error");

  const submitHandler = async () => {
    setStatus("loading");
    emailAuth.removeJwtToken();
    try {
      await instance.clearCache();
      instance.setActiveAccount(null);
      const response = await fetch(baseUrl + "/v2/auth/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });

      if (response.status === 200) {
        const data = (await response.json()) as { access_token: string };
        const accessToken = data.access_token;
        if (accessToken) {
          emailAuth.setJwtToken(accessToken);
          void navigate("/invitation/user", { replace: true });
        } else {
          setStatus("error");
        }
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <Stack spacing={10} alignItems="center" width="100%">
      <Stack
        spacing={2}
        paddingTop={4}
        alignItems="center"
        textAlign="center"
        maxWidth="500px"
      >
        <Stack spacing={2} paddingBottom={6}>
          <Typography variant="h5">{t("tokenHandler.info")}</Typography>

          {email && <Typography variant="h6">{email}</Typography>}
          {status === "error" ? (
            <>
              <Alert severity="error">{t("tokenHandler.error")}</Alert>
              <Typography variant="h6">
                <Trans i18nKey="tokenHandler.requestNewLink" t={t}>
                  <Link component={RouterLink} to="/invitation/login">
                    täältä
                  </Link>
                </Trans>
              </Typography>
            </>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                void submitHandler();
              }}
            >
              <Button
                variant="contained"
                sx={{ px: "5em", marginTop: "1em" }}
                type="submit"
                loading={status === "loading"}
                disabled={status === "loading"}
              >
                {t("tokenHandler.submit")}
              </Button>
            </form>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TokenHandler;
